<template>
  <v-container>
    <h1>Umfrage Statistiken</h1>
    <Pending v-model="statsPromise">
      <div v-if="stats.length" class="stat-header mt-8 pa-4 total-stats">
        <div class="stat-label">
          <strong>Gesamt</strong><br>
          <small>{{ stats.length }} Befragungen</small>
        </div>
        <div class="stat-bar">
          <SurveyProgressBar
            :total="totals.tokens"
            :started-count="totals.started"
            :finished-count="totals.finished"
          />
        </div>
      </div>

      <v-expansion-panels class="mt-8">
        <v-expansion-panel
          v-for="(stat, i) in stats"
          :key="i"
        >
          <v-expansion-panel-header>
            <div class="stat-header">
              <div class="stat-label">
                {{ stat.client.name }}<br>
                <small>{{ stat.survey.title }}</small>
              </div>
              <div class="stat-bar">
                <SurveyProgressBar
                  :total="stat.tokens_generated"
                  :started-count="stat.surveys_started.count"
                  :finished-count="stat.surveys_finished.count"
                />
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Klinik</td>
                    <td>{{ stat.client.name }}</td>
                  </tr>
                  <tr>
                    <td>Befragung</td>
                    <td>{{ stat.survey.title }}</td>
                  </tr>
                  <tr>
                    <td>Anzahl der Fragen</td>
                    <td v-if="stat.survey.question_count.min === stat.survey.question_count.max">{{ stat.survey.question_count.min }}</td>
                    <td v-else>{{ stat.survey.question_count.min }} - {{ stat.survey.question_count.max }} Fragen</td>
                  </tr>
                  <tr>
                    <td>Zugangscodes Gesamtanzahl</td>
                    <td>{{ stat.tokens_generated }}</td>
                  </tr>
                  <tr>
                    <td>Zugangscodes aktiviert</td>
                    <td>{{ stat.tokens_activated.count }} ({{ stat.tokens_activated.percentage_of_tokens_generated.toFixed(1) }}%)</td>
                  </tr>
                  <tr>
                    <td>Befragungen begonnen</td>
                    <td>{{ stat.surveys_started.count }} ({{ stat.surveys_started.percentage_of_tokens_generated.toFixed(1) }}%)</td>
                  </tr>
                  <tr>
                    <td>Befragungen abgeschlossen</td>
                    <td>{{ stat.surveys_finished.count }} ({{ stat.surveys_finished.percentage_of_tokens_generated.toFixed(1) }}%)</td>
                  </tr>
                  <tr>
                    <td>Mittlere Anzahl Antworten<br><small> (bei {{ stat.surveys_started.count }} begonnenen Befragungen) </small></td>
                    <td>
                      {{ stat.questions_answered.average_count.toFixed(1) }} Antworten
                    </td>
                  </tr>
                  <tr>
                    <td>Mittlere Antwortrate<br><small> (bei {{ stat.surveys_started.count }} begonnenen Befragungen) </small></td>
                    <td>
                      <span v-if="stat.questions_answered.average_percentage_min === stat.questions_answered.average_percentage_max">
                        {{ stat.questions_answered.average_percentage_min.toFixed(1) }}% Antwortrate
                      </span>
                      <span v-else>
                        zwischen {{ stat.questions_answered.average_percentage_min.toFixed(1) }}% und {{ stat.questions_answered.average_percentage_max.toFixed(1) }}%
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </Pending>
  </v-container>
</template>

<script>
import axios from 'axios'
import SurveyProgressBar from './SurveyProgressBar.vue'

export default {
  name: 'SurveyStats',
  components: {
    SurveyProgressBar,
  },
  data: () => ({
    panel: null,
    pending: false,
    statsPromise: null,
    stats: [],
  }),
  computed: {
    totals() {
      return this.stats.reduce((sum, stat) => ({
        tokens: sum.tokens + stat.tokens_generated,
        started: sum.started + stat.surveys_started.count,
        finished: sum.finished + stat.surveys_finished.count,
      }), { tokens: 0, started: 0, finished: 0 })
    },
  },
  created() {
    this.fetchStats()
  },
  methods: {
    fetchStats() {
      this.statsPromise = axios.get(this.$store.state.apiPath + '/survey-access/stats')
      this.statsPromise.then(response => {
        this.stats = response.data
      })
    },
  }
}
</script>

<style scoped>

  .stat-header {
    margin-right: 1em;
    display: flex;
    align-items: center;
  }

  .stat-label {
    width: 40%;
    font-size: 14px;
    color: #333;
  }

  .stat-bar {
    width: 60%;
  }

  .total-stats {
    margin-right: 0;
    padding-right: 40px !important;
  }
</style>